export default __webpack_public_path__ + "static/media/advicegradissuegfx-02.953b6849.png";